import React from 'react';
import { motion } from 'framer-motion';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import SustainabilitySection from '../sections/SustainabilitySection';
import CertStrip from '../components/CertStrip';

export default function Sustainability() {
  return (
    <motion.main
      id="main"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <Navigation />
      <PageHero
        kicker="Theme 03 · Sustainability"
        title="Harmony through sustainability"
        subtitle="Green leads when the story is impact. Built for ESG, circularity and bio-based material narratives."
        variant="eco"
        theme="sustainability"
      />
      <CertStrip />
      <SustainabilitySection fullPage />
      <Footer />
    </motion.main>
  );
}
